export const GET_TEAM = "GET_TEAM";
export const SET_TEAM = "SET_TEAM";
export const SET_TEAM_ZERO = "SET_TEAM_ZERO";
